
export enum Species {
    FELINE = 1,
    CANINE = 2
}
